import { VFC } from 'react';

import { WorkflowVersionStepDiff } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVisualVersionDiff/types';
import { valueDiffIsNotEmpty } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVisualVersionDiff/utils';
import { ValueDiffLabel } from 'dashboard/apps/InquiryTemplateEditor/ValueDiffLabel';
import { PropertyRow } from 'dashboard/apps/InquiryTemplateEditor/VersionDiffTable';
import { WorkflowStepParallel } from 'dashboard/models/workflow-version';

interface ParallelDifferProps {
  step: WorkflowStepParallel;
  workflowStepDiff?: WorkflowVersionStepDiff;
}

const ParallelDiffer: VFC<ParallelDifferProps> = ({ workflowStepDiff, step }) => {
  const branchDiff = workflowStepDiff?.changes?.branches || null;
  return (
    <>
      <PropertyRow textKey='Step Type' value='Parallel' />
      <PropertyRow
        textKey='Branches'
        value={
          branchDiff != null && valueDiffIsNotEmpty(branchDiff) ? (
            <ValueDiffLabel valueDiff={branchDiff} fallbackValue='None' />
          ) : (
            step.branches.length
          )
        }
      />
    </>
  );
};

export default ParallelDiffer;
